<template>
  <SkeletonLoader>
    <div class="kanban-skeleton">
      <!-- Header -->
      <div class="kanban-skeleton__header">
        <div class="sk-rect kanban-skeleton__dropdown"></div>
        <div class="sk-rect kanban-skeleton__search"></div>
        <div class="sk-rect kanban-skeleton__button"></div>
      </div>

      <!-- Mobile: column selector + single column -->
      <div class="kanban-skeleton__mobile">
        <div class="sk-rect kanban-skeleton__column-selector"></div>
        <div class="kanban-skeleton__column">
          <div class="kanban-skeleton__column-header">
            <div class="sk-line" :style="{ width: columns[0].nameWidth }"></div>
            <div class="sk-rect kanban-skeleton__badge"></div>
          </div>
          <div
            v-for="card in columns[0].cards"
            :key="'mobile-' + card.id"
            class="kanban-skeleton__card"
          >
            <div class="sk-line" :style="{ width: card.titleWidth }"></div>
            <div class="sk-line sk-line--sm" :style="{ width: card.descWidth }"></div>
          </div>
        </div>
      </div>

      <!-- Desktop: 4 columns side by side -->
      <div class="kanban-skeleton__board">
        <div
          v-for="col in columns"
          :key="col.id"
          class="kanban-skeleton__column"
        >
          <div class="kanban-skeleton__column-header">
            <div class="sk-line" :style="{ width: col.nameWidth }"></div>
            <div class="sk-rect kanban-skeleton__badge"></div>
          </div>
          <div
            v-for="card in col.cards"
            :key="card.id"
            class="kanban-skeleton__card"
          >
            <div class="sk-line" :style="{ width: card.titleWidth }"></div>
            <div class="sk-line sk-line--sm" :style="{ width: card.descWidth }"></div>
          </div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue'

export default {
  name: 'KanbanSkeleton',
  components: { SkeletonLoader },
  data () {
    return {
      columns: [
        {
          id: 'col-1',
          nameWidth: '80px',
          cards: [
            { id: 'c1-1', titleWidth: '70%', descWidth: '90%' },
            { id: 'c1-2', titleWidth: '55%', descWidth: '80%' },
            { id: 'c1-3', titleWidth: '65%', descWidth: '75%' }
          ]
        },
        {
          id: 'col-2',
          nameWidth: '100px',
          cards: [
            { id: 'c2-1', titleWidth: '60%', descWidth: '85%' },
            { id: 'c2-2', titleWidth: '75%', descWidth: '70%' },
            { id: 'c2-3', titleWidth: '50%', descWidth: '90%' },
            { id: 'c2-4', titleWidth: '68%', descWidth: '78%' }
          ]
        },
        {
          id: 'col-3',
          nameWidth: '70px',
          cards: [
            { id: 'c3-1', titleWidth: '65%', descWidth: '88%' },
            { id: 'c3-2', titleWidth: '72%', descWidth: '76%' },
            { id: 'c3-3', titleWidth: '58%', descWidth: '82%' }
          ]
        },
        {
          id: 'col-4',
          nameWidth: '90px',
          cards: [
            { id: 'c4-1', titleWidth: '68%', descWidth: '80%' },
            { id: 'c4-2', titleWidth: '55%', descWidth: '92%' }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.kanban-skeleton {
  padding: 16px;

  &__header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
  }

  &__dropdown {
    width: 180px;
    height: 36px;
  }

  &__search {
    width: 200px;
    height: 36px;
  }

  &__button {
    width: 100px;
    height: 36px;
  }

  &__mobile {
    display: none;
  }

  &__column-selector {
    width: 100%;
    height: 40px;
    margin-bottom: 12px;
  }

  &__board {
    display: flex;
    gap: 16px;
  }

  &__column {
    flex: 1;
    min-width: 0;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px;
  }

  &__column-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e2e8f0;

    .sk-line {
      margin-bottom: 0;
    }
  }

  &__badge {
    width: 28px;
    height: 20px;
    border-radius: 10px;
    flex-shrink: 0;
  }

  &__card {
    background: #fff;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    min-height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:last-child {
      margin-bottom: 0;
    }

    .sk-line {
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

@media (max-width: 768px) {
  .kanban-skeleton {
    &__header {
      flex-wrap: wrap;
    }

    &__dropdown {
      width: 100%;
    }

    &__search {
      flex: 1;
      min-width: 120px;
    }

    &__mobile {
      display: block;
    }

    &__board {
      display: none;
    }
  }
}
</style>
